export default "__VITE_ASSET__BE_GQS2V__"